<template>
    <ul class="cell_content">
        <li class="cell_item">
            <span class="cell_label">{{label}}</span>
            <span class="cell_value">{{value}} </span>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        label: String,
        value: String
    }
}
</script>

<style scoped>
.cell_content{
    width: 100%;
    height: 50px;
    line-height: 50px;
   border-bottom: 1px solid #eee8e8;

}
.cell_item{
    height: 50px;
    display: flex;
    background: #fff;
    justify-content: space-between;
    padding: 0 3%;
}
.cell_label{
    font-size: 15px;
}
.cell_value{
    color: #999;
}
.right_jiantou{
    font-size: 25px;
    clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/cell.vue